// extracted by mini-css-extract-plugin
export var button = "_ho-2";
export var card = "_ho-0";
export var closeButtonContainer = "_ho-3";
export var iconContainer = "_ho-1";